import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Ref, ref } from 'vue'
import { useRouter } from 'vue-router'
import {
  UpdateSalesPointOpts,
  SalesPoint,
  SalesPointsService,
  MunicipalEntitiesService,
  Id,
  AppAuthService,
  UsersService,
  AddressSuggesterService,
} from '@prodcard/core'
import SalesPointsForm from './SalesPointsForm.vue'
import { CardHeader } from '../../../../components'
import { createCtx, handleError, callSuccessToast } from '../../../../helpers'
import { isEmpty, isEqual, pickBy } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesPointsEditPage',
  props: {
    authService: {},
    salesPointsService: {},
    municipalEntitiesService: {},
    usersService: {},
    addressSuggesterService: {},
    id: {}
  },
  setup(__props: any) {

const props = __props;



const router = useRouter()

const salesPoint: Ref<SalesPoint | undefined> = ref(undefined)
const salesPointLoading = ref(false)
const loading = ref(false)
const disabled = ref(false)

const submit = (opts: UpdateSalesPointOpts) => {
  const aggregateOpts = pickBy(opts, (val, key) => {
    if (!val && !salesPoint.value?.[key as keyof SalesPoint]) return false
    if (!isEqual(salesPoint.value?.[key as keyof SalesPoint], val)) return true
    return !val
  })

  if (isEmpty(aggregateOpts)) return

  handleError(async () => {
    await props.salesPointsService.update(createCtx(), props.id, aggregateOpts)
    callSuccessToast('Данные торгового объекта сохранены')
    router?.back()
  }, loading)
}

handleError(async () => {
  salesPoint.value = await props.salesPointsService.findById(createCtx(), props.id)
}, salesPointLoading)

const deleteSalesPoint = (id: Id) => {
  handleError(async () => {
    await props.salesPointsService.delete(createCtx(), id)
    callSuccessToast('Торговый объект удален')
    router?.back()
  }, loading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            loading: loading.value || disabled.value || salesPointLoading.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CardHeader), null, {
                    title: _withCtx(() => [
                      _createTextVNode(" Редактирование торгового объекта ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "mt-8 pa-0" }, {
                default: _withCtx(() => [
                  (salesPoint.value && !salesPointLoading.value)
                    ? (_openBlock(), _createBlock(SalesPointsForm, {
                        key: 0,
                        "users-service": _ctx.usersService,
                        "address-suggester-service": _ctx.addressSuggesterService,
                        "auth-service": _ctx.authService,
                        "sales-point": salesPoint.value,
                        "municipal-entities-service": _ctx.municipalEntitiesService,
                        loading: loading.value,
                        disabled: disabled.value,
                        onSubmit: submit,
                        onDelete: deleteSalesPoint
                      }, null, 8, ["users-service", "address-suggester-service", "auth-service", "sales-point", "municipal-entities-service", "loading", "disabled"]))
                    : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                        key: 1,
                        type: "heading@8, actions"
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})